import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label"]
  static values = { text: String }

  async copy() {
    const text = this.hasTextValue ? this.textValue : this.element.textContent
    try {
      await navigator.clipboard.writeText(text)
      if (this.hasLabelTarget) {
        const original = this.labelTarget.textContent
        this.labelTarget.textContent = "Copied!"
        setTimeout(() => {
          this.labelTarget.textContent = original
        }, 2000)
      }
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }
}
